import {
  Building2,
  ClipboardList,
  Clock,
  DollarSign,
  FileSignature,
  FileText,
  GraduationCap,
  KeyRound,
  LayoutDashboard,
  Map,
  Megaphone,
  MessageSquare,
  Settings,
  Shield,
  ShieldCheck,
  Store,
  User,
  Users,
  Wallet,
  Boxes,
  type LucideIcon,
} from 'lucide-react';
import type { AppRole } from '@/hooks/useUserRole';

export type AdminMenuRole = AppRole | 'super_admin';

export type AdminMenuItem = {
  label: string;
  href: string;
  icon: LucideIcon;
  featureFlag?: string;
  requiredRoles?: AdminMenuRole[];
  requiredPermissions?: string[];
  hidden?: boolean;
  end?: boolean;
  badge?: 'pendingApplications';
};

export type AdminMenuGroup = {
  id: 'operations' | 'people' | 'verification' | 'resources' | 'settings';
  label: string;
  items: AdminMenuItem[];
};

export const adminMenuGroups: AdminMenuGroup[] = [
  {
    id: 'operations',
    label: 'Operations',
    items: [
      {
        label: 'Dashboard',
        href: '/admin',
        icon: LayoutDashboard,
        end: true,
      },
      {
        label: 'Campaigns',
        href: '/admin/campaigns',
        icon: Megaphone,
      },
      {
        label: 'Applications',
        href: '/admin/applications',
        icon: ClipboardList,
        badge: 'pendingApplications',
      },
      {
        label: 'Surveys',
        href: '/admin/surveys',
        icon: FileText,
      },
      {
        label: 'Courses',
        href: '/admin/training',
        icon: GraduationCap,
      },
      {
        label: 'Rollout',
        href: '/admin/rollout',
        icon: Map,
        featureFlag: 'rollout',
      },
    ],
  },
  {
    id: 'people',
    label: 'People',
    items: [
      {
        label: 'Users',
        href: '/admin/users',
        icon: Users,
        requiredRoles: ['admin', 'super_admin'],
      },
      {
        label: 'Clients',
        href: '/admin/clients',
        icon: Building2,
      },
      {
        label: 'Promoters',
        href: '/admin/promoters',
        icon: Users,
      },
    ],
  },
  {
    id: 'verification',
    label: 'Verification',
    items: [
      {
        label: 'Overview',
        href: '/admin/verification-overview',
        icon: ShieldCheck,
      },
      {
        label: 'Promoter Changes',
        href: '/admin/promoter-changes',
        icon: User,
      },
      {
        label: 'Verify ID',
        href: '/admin/verify-id',
        icon: ShieldCheck,
      },
      {
        label: 'Banking Verification',
        href: '/admin/banking',
        icon: Wallet,
      },
      {
        label: 'Wages',
        href: '/admin/wages-verification',
        icon: DollarSign,
      },
      {
        label: 'BUD Approval',
        href: '/admin/bud-approval',
        icon: ShieldCheck,
        requiredRoles: ['bud', 'business_unit_director', 'super_admin'],
      },
      {
        label: 'Clock In Reports',
        href: '/admin/clock-reports',
        icon: Clock,
      },
    ],
  },
  {
    id: 'resources',
    label: 'Resources',
    items: [
      {
        label: 'Wages',
        href: '/admin/wages',
        icon: DollarSign,
      },
      {
        label: 'Messaging',
        href: '/admin/messaging',
        icon: MessageSquare,
      },
      {
        label: 'Store Universe',
        href: '/admin/stores',
        icon: Store,
      },
      {
        label: 'Inventory',
        href: '/admin/inventory',
        icon: Boxes,
      },
      {
        label: 'Contracts',
        href: '/admin/contracts',
        icon: FileSignature,
      },
      {
        label: 'Policies',
        href: '/admin/policies',
        icon: ShieldCheck,
        featureFlag: 'policies',
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    items: [
      {
        label: 'Profile',
        href: '/admin/profile',
        icon: User,
      },
      {
        label: 'Settings',
        href: '/admin/settings',
        icon: Settings,
        featureFlag: 'settings',
      },
      {
        label: 'Access Control',
        href: '/admin/access-control',
        icon: KeyRound,
        requiredPermissions: ['settings.manage'],
      },
      {
        label: 'Security',
        href: '/admin/security',
        icon: Shield,
        requiredRoles: ['super_admin'],
      },
    ],
  },
];
